<template>
  <div class="uikit-page">
    <div>
      <table-columns-modal
        ref="tableColumnsModal"
        :columns="columns"
        :default-selected="defaultSelectedColumns"
        @apply="selectedColumns = $event"
      ></table-columns-modal>
      <c-button responsive icon="cog" label="Настроить столбцы" @click="configureColumns" />
    </div>

    <div class="layout__hr"></div>

    <div>
      <comment-modal ref="commentModal"></comment-modal>

      <link-modal ref="linkModal" title="Ссылка на Google Таблицы"></link-modal>

      <div class="d-flex">
        <c-button-2
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Комментарий',
            placement: 'top',
          }"
          class="mr-4"
          size="iconic"
          icon="comment"
          @click="showComment()"
        ></c-button-2>
        <c-button
          :icon="{
            icon: 'google',
            color: 'green',
          }"
          label="Выгрузить в Google таблицы"
          responsive
          @click="copyLink"
        />
      </div>
    </div>

    <div class="layout__hr"></div>

    <div class="row">
      <div class="col-6">
        <h3 class="layout__subtitle">Фильтры для разных типов данных</h3>

        <column-filter-modal ref="columnFilterModal" @apply="applyColumnFilter" />

        <table class="h-table">
          <thead>
            <tr>
              <td v-for="filter in filters" :key="filter.type">
                {{ filter.type }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="filter in filters" :key="filter.type">
                <c-button
                  :icon="{
                    icon: 'filter-column',
                    activeColor: 'blue',
                  }"
                  :tooltip="{
                    text: 'Применить фильтр',
                    activeText: 'Изменить фильтр',
                  }"
                  no-border
                  size="small"
                  :active="filter.value"
                  @click="configureColumnFilter(filter)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Column } from "@/entities/structures/column";

import Button from "@/components/controls/button";
import Button2 from "@/components/controls2/Button";

import TableColumnsModal from "@/components/modals/table-columns/modal/";
import ColumnFilterModal from "@/components/modals/column-filter-modal/";
import CommentModal from "@/components/modals/comment-modal/";
import LinkModal from "@/components/modals/link-modal/";

export default {
  components: {
    "c-button": Button,
    "c-button-2": Button2,
    TableColumnsModal,
    ColumnFilterModal,
    CommentModal,
    LinkModal,
  },
  data() {
    return {
      columns: [],
      defaultSelectedColumns: ["fullName"],
      selectedColumns: [],

      filters: [
        {
          type: "number",
          name: "number",
          value: null,
        },
        {
          type: "string",
          name: "string",
          value: null,
        },
        {
          type: "date",
          name: "date",
          value: null,
        },
        {
          type: "list",
          name: "list",
          value: null,
        },
      ],
    };
  },
  created() {
    this.loadColumns();
  },
  methods: {
    loadColumns() {
      this.$store.dispatch("uikit/loadColumns").then((items) => {
        this.columns = items.map((i) => new Column(i));
      });
    },
    configureColumns() {
      this.$refs.tableColumnsModal.open(this.selectedColumns);
    },

    getValuesList() {
      return new Promise((res) => {
        res([
          { value: 1, label: "Значение 1" },
          { value: 2, label: "Значение 2" },
          { value: 3, label: "Значение 3" },
          { value: 4, label: "Значение 4" },
          { value: 5, label: "Значение 5" },
        ]);
      });
    },
    configureColumnFilter(filter) {
      this.$refs.columnFilterModal.open({
        type: filter.type,
        name: filter.name,
        value: filter.value,
        getList: () => this.getValuesList(),
      });
    },
    applyColumnFilter(params) {
      this.filters = this.filters.map((filter) => {
        if (filter.name === params.name) {
          return {
            ...filter,
            value: params.value,
          };
        }
        return filter;
      });
    },

    showComment() {
      this.$refs.commentModal.open("Текст комментария");
    },

    copyLink() {
      this.$refs.linkModal.open("https://docs.google.com/spreadsheets/d/1xDsB1f1IfAO2z7-f2zcT/edit#gsfjlsjdf");
    },
  },
};
</script>
